<i18n>
    {
        "ru": {
            "default_placeholder": "Поиск по энциклопедии...",
            "placeholder": "Поиск по энциклопедии из {total}",
            "perfumes": "Ароматы",
            "brands": "Бренды",
            "content": "В тексте",
            "no_results": "Ничего не найдено",
            "copyright": "Aromo.ru&nbsp;&mdash; Энциклопедия парфюмерии",
            "rights": "Все права защищены, (с)",
            "nav": {
                "encyclopedia": "Энциклопедия",
                "journal": "Журнал",
                "pages": "Другие разделы"
            },
            "docs": {
                "terms-of-use": "Пользовательское соглашение",
                "privacy-policy": "Политика конфиденциальности",
                "copyright-holders-policy": "Правообладателям"
            },
            "site-map": "Карта сайта",
            "pc": "Полная версия сайта",
            "mobile": "Вернуться в мобильную версию",
            "confirm_text": "Внимание! Вы действительно хотите покинуть мобильный сайт и перейти к полной версии?"
        },
        "en": {
            "copyright": "Perfume Community",
            "rights": "All rights reserved ©",
            "nav": {
                "catalog": "Navigation",
                "pages": "Other pages"
            }
        }
    }
</i18n>

<template>
    <div class="amp-layout-container">

        <div class="amp-layout-target-observer" id="top">
            <amp-position-observer on="enter:hideAnim.start; exit:showAnim.start" layout="nodisplay" />
        </div>

        <amp-sidebar class="amp-layout-menu"
            id="menu"
            layout="nodisplay"
            side="left">
            <div class="sidebar__wrap">
                <div class="sidebar__head">
                    <svg-icon :name="'logo-' + $i18n.locale" :class="'sidebar__logo sidebar__logo_'+$i18n.locale" />
                </div>
                <div class="sidebar__body">
                    <div class="sidebar__scrolled">

                        <div class="nav nav_catalog sidebar__nav">
                            <div class="nav__item"
                                v-for="(item, index) in items('catalog', false, 5, false)"
                                :key="index">
                                <a :href="item.url || '/'"
                                    class="nav__link"
                                    :class="{'nav__link_new': isNew(item)}">
                                    <svg-icon
                                        class="nav__icon"
                                        :class="'nav__icon_' + index"
                                        :name="item.icon || ['nav', 'catalog', index].join('-')"/>
                                    <span class="nav__link-text">
                                        {{ getTranslation(index) }}
                                        <span class="nav__counter" v-if="counters[index] && item.showCounter">{{ getCountersDeclension(counters[index].total) }}</span>
                                    </span>
                                </a>
                            </div>
                            <amp-accordion
                                id="menu_1"
                                class="test"
                                animate
                                disable-session-states>
                                <section id="menu_1_1" class="nav__hidden">
                                    <h3 class="nav__toggle">
                                        <div class="nav__toggle-text"
                                            :data-show="$t('nav.show_more')"
                                            :data-hide="$t('nav.hide')">
                                        </div>
                                    </h3>
                                    <div>
                                        <div class="nav__item"
                                            v-for="(item, index) in items('catalog', false, false, 5)"
                                            :key="index">
                                            <a :href="item.url || '/'"
                                                class="nav__link"
                                                :class="{'nav__link_new': isNew(item)}">
                                                <svg-icon
                                                    class="nav__icon"
                                                    :class="'nav__icon_' + index"
                                                    :name="item.icon || ['nav', 'catalog', index].join('-')"/>
                                                <span class="nav__link-text">{{ getTranslation(index) }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </section>
                            </amp-accordion>
                        </div>

                        <div class="nav nav_sections sidebar__nav sidebar__sections">
                            <div class="nav__item"
                                v-for="(item, index) in items('sections', false)"
                                :key="index">
                                <a :href="item.url || '/'"
                                    class="nav__link"
                                    :class="{
                                        'nav__link_current': isCurrent(item.url),
                                        'nav__link_new': isNew(item)
                                    }">
                                    <span class="nav__link-text">{{ getTranslation(index) }}</span>
                                </a>
                            </div>
                        </div>

                        <div class="nav sidebar__pages nav_pages">
                            <div class="nav__item"
                                v-for="(item, index) in items('pages', false)"
                                :key="index">
                                <a :href="item.url || '/'"
                                    class="nav__link"
                                    :class="{
                                        'nav__link_current': isCurrent(item.url),
                                        'nav__link_new': isNew(item)
                                    }">
                                    <span class="nav__link-text">{{ getTranslation(index) }}</span>
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </amp-sidebar>
        
        <header class="amp-layout-header">
            
            <div class="amp-layout-header__top">
                <div class="amp-layout-header__burger"
                    role="button"
                    on="tap:menu.toggle"
                    tabindex="0">
                    <svg-icon name="sidebar-opener" class="header__burger-icon" />
                </div>
                <a href="/" 
                    aria-label="Aromo.ru"
                    class="amp-layout-header__logo">
                    <!-- eslint-disable-next-line -->
                    <svg class="amp-layout-header__logo-svg" width="91" height="15" viewBox="0 0 91 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <!-- eslint-disable-next-line -->
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M89.02 12.918c-1.326 1.305-3.132 1.957-5.418 1.957-1.496 0-2.794-.293-3.895-.877a5.96 5.96 0 0 1-2.532-2.553c-.588-1.116-.881-2.437-.881-3.96 0-1.567.293-2.908.881-4.025A6.058 6.058 0 0 1 79.707.892C80.808.297 82.107 0 83.602 0c1.538 0 2.858.297 3.959.892a6.166 6.166 0 0 1 2.548 2.568c.598 1.117.897 2.458.897 4.024 0 2.317-.662 4.129-1.986 5.434Zm-2.26-9.082c-.695-.846-1.748-1.268-3.158-1.268-1.346 0-2.367.422-3.062 1.268-.694.845-1.04 2.062-1.04 3.648 0 1.565.346 2.766 1.04 3.601.695.836 1.716 1.253 3.062 1.253 1.41 0 2.463-.417 3.158-1.253.694-.835 1.04-2.036 1.04-3.6 0-1.587-.346-2.804-1.04-3.65Zm-19.188 8h1.314v-5.73c0-1.253-.214-2.14-.64-2.662-.428-.522-1.155-.783-2.18-.783-.556 0-1.127.1-1.715.298-.588.199-1.053.454-1.394.767v8.11h1.314v2.506h-5.898v-2.505h1.346V6.106c0-1.253-.208-2.14-.625-2.662-.417-.522-1.138-.783-2.163-.783-.556 0-1.128.1-1.715.298-.59.199-1.064.454-1.427.767v8.11h1.346v2.506h-7.244v-2.505h2.66V3.632l-3.044-.97.833-2.506 4.455 1.44A7.572 7.572 0 0 1 54.96.423 7.15 7.15 0 0 1 57.347 0c.962 0 1.822.146 2.58.438.759.293 1.373.72 1.843 1.284.598-.502 1.315-.913 2.148-1.237A6.939 6.939 0 0 1 66.45 0c1.987 0 3.424.454 4.31 1.361.887.91 1.33 2.386 1.33 4.432v6.044h2.726v2.505h-7.245v-2.505Zm-28.816 3.039c-1.496 0-2.794-.293-3.895-.877a5.96 5.96 0 0 1-2.532-2.553c-.588-1.116-.881-2.437-.881-3.96 0-1.567.293-2.908.881-4.025A6.058 6.058 0 0 1 34.861.892C35.962.297 37.261 0 38.756 0c1.538 0 2.858.297 3.959.892a6.167 6.167 0 0 1 2.548 2.568c.598 1.117.897 2.458.897 4.024 0 2.317-.662 4.129-1.986 5.434-1.326 1.305-3.132 1.957-5.418 1.957Zm3.158-11.04c-.695-.845-1.748-1.267-3.158-1.267-1.346 0-2.367.422-3.062 1.268-.694.845-1.04 2.062-1.04 3.648 0 1.565.346 2.766 1.04 3.601.695.836 1.716 1.253 3.062 1.253 1.41 0 2.463-.417 3.158-1.253.694-.835 1.04-2.036 1.04-3.6 0-1.587-.346-2.804-1.04-3.65ZM26.996 2.819a9.046 9.046 0 0 0-2.02.344 6.056 6.056 0 0 0-1.666.752l-.033 7.923h3.142v2.505h-9.04v-2.505h2.693V3.694l-3.077-1.001.865-2.537 4.552 1.503A9.948 9.948 0 0 1 24.96.454a8.922 8.922 0 0 1 2.58-.392c.79 0 1.421.094 1.892.282l.545 3.633-2.66.564-.321-1.723ZM10.45 13.591c-1.453.855-2.97 1.284-4.552 1.284-1.923 0-3.381-.367-4.375-1.097C.53 13.048.022 11.983 0 10.584c-.021-2.86 1.87-4.29 5.674-4.29l3.782.032c0-1.316-.262-2.292-.785-2.929-.524-.636-1.256-.955-2.196-.955-.492 0-.961.031-1.41.094a8.15 8.15 0 0 0-1.282.282l-.321 1.628-2.66-.407.577-3.131A16.645 16.645 0 0 1 3.91.235 14.16 14.16 0 0 1 6.476 0c2.03 0 3.574.527 4.632 1.581 1.058 1.055 1.587 2.605 1.587 4.65v5.293l2.82.908L14.682 15l-4.231-1.41Zm-.994-5.074H5.77c-.79 0-1.4.172-1.827.517-.428.345-.641.841-.641 1.488 0 1.294.908 1.941 2.725 1.941 1.282 0 2.425-.333 3.43-1.002V8.517Z" fill="#141414"/>
                    </svg>
                </a>
                <a :href="$auth.loggedIn ? `/users/${user.id}/notifications/` : canonicalUrl"
                    class="amp-layout-header__notices"
                    :class="{'amp-layout-header__notices_unread': unreadNotifications > 0}">
                    <svg-icon name="icon-bell" class="header__notify-icon" />
                </a>
                <a v-if="$auth.loggedIn"
                    :href="`/users/${user.id}`"
                    class="amp-layout-header__user">
                    <svg-icon name="icon-user" class="header__profile-icon" />
                </a>
                <a v-else
                    :href="canonicalUrl + '#popup-signin'"
                    class="amp-layout-header__user">
                    <svg-icon name="header-signin" class="header__signin-icon" />
                </a>
            </div>

            <a :href="canonicalUrl" class="amp-layout-header__search">{{ placeholder || $t('default_placeholder') }}</a>

        </header>

        <Nuxt />

        <footer class="amp-layout-footer footer">

            <div class="amp-layout-footer__inner">

                <amp-accordion
                    class="amp-layout-footer__menu"
                    animate
                    disable-session-states>
                    <section class="footer__nav footer-nav">
                        <h3 class="footer-nav__head">{{ $t('nav.encyclopedia') }}</h3>
                        <div class="footer-nav__body">
                            <div class="nav footer__catalog nav_catalog nav_footer-sections">
                                <div class="nav__item"
                                    v-for="(item, index) in items('catalog', navs.encyclopedia.sort)"
                                    :key="index">
                                    <a :href="item.url" class="nav__link">
                                        <span class="nav__link-text">{{ getTranslation(index) }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="footer__nav footer-nav">
                        <h3 class="footer-nav__head">{{ $t('nav.journal') }}</h3>
                        <div class="footer-nav__body">
                            <div class="nav footer__pages nav_sections nav_footer-pages">
                                <div class="nav__item"
                                    v-for="(item, index) in items('sections', navs.journal.sort)"
                                    :key="index">
                                    <a :href="item.url" class="nav__link">
                                        <span class="nav__link-text">{{ getTranslation(index) }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>
                    <section class="footer__nav footer-nav">
                        <h3 class="footer-nav__head">{{ $t('nav.pages') }}</h3>
                        <div class="footer-nav__body">
                            <div class="nav footer__pages nav_pages nav_footer-pages">
                                <div class="nav__item"
                                    v-for="(item, index) in items('pages', navs.journal.pages)"
                                    :key="index">
                                    <a :href="item.url" class="nav__link">
                                        <span class="nav__link-text">{{ getTranslation(index) }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </section>
                </amp-accordion>

                <div class="footer__documents">
                    <div class="footer__document">
                        <html-link
                            to="/legal/terms-of-use/"
                            class="footer__document-link">
                            {{ $t('docs.terms-of-use') }}
                        </html-link>
                    </div>
                    <div class="footer__document">
                        <html-link
                            to="/legal/privacy-policy/"
                            class="footer__document-link">
                            {{ $t('docs.privacy-policy') }}
                        </html-link>
                    </div>
                    <div class="footer__document">
                        <html-link
                            to="/legal/for-right-holgers/"
                            class="footer__document-link">
                            {{ $t('docs.copyright-holders-policy') }}
                        </html-link>
                    </div>
                    <div class="footer__document">
                        <nuxt-link
                            to="/sitemap/"
                            class="footer__document-link">
                            {{ $t('site-map') }}
                        </nuxt-link>
                    </div>
                </div>

                <div class="footer__social-block social-block social-block_links">
                    <a v-if="getSocialLinkUrl('yt')"
                        target="_blank"
                        rel="nofollow noreferrer"
                        :href="getSocialLinkUrl('yt')"
                        class="social-block__link"
                        aria-label="youtube">
                        <svg-icon name="icon-social-youtube" class="social-block__icon" />
                    </a>
                    <!-- <a v-if="getSocialLinkUrl('in')"
                        target="_blank"
                        rel="nofollow noreferrer"
                        :href="getSocialLinkUrl('in')"
                        class="social-block__link"
                        aria-label="instagram">
                        <svg-icon name="icon-social-ins" class="social-block__icon" />
                    </a> -->
                    <a v-if="getSocialLinkUrl('tg')"
                        target="_blank"
                        rel="nofollow noreferrer"
                        :href="getSocialLinkUrl('tg')"
                        class="social-block__link"
                        aria-label="telegram">
                        <svg-icon name="icon-social-tg" class="social-block__icon" />
                    </a>
                    <!-- <a v-if="getSocialLinkUrl('fb')"
                        target="_blank"
                        rel="nofollow noreferrer"
                        :href="getSocialLinkUrl('fb')"
                        class="social-block__link"
                        aria-label="facebook">
                        <svg-icon name="icon-social-fb" class="social-block__icon" />
                    </a> -->
                    <a v-if="getSocialLinkUrl('vk')"
                        target="_blank"
                        rel="nofollow noreferrer"
                        :href="getSocialLinkUrl('vk')"
                        class="social-block__link"
                        aria-label="vkontakte">
                        <svg-icon name="icon-social-vk" class="social-block__icon" />
                    </a>
                    <!-- <a v-if="getSocialLinkUrl('tw')"
                        target="_blank"
                        rel="nofollow noreferrer"
                        :href="getSocialLinkUrl('tw')"
                        class="social-block__link"
                        aria-label="twitter">
                        <svg-icon name="icon-social-tw" class="social-block__icon" />
                    </a> -->
                    <a v-if="getSocialLinkUrl('ok')"
                        target="_blank"
                        rel="nofollow noreferrer"
                        :href="getSocialLinkUrl('ok')"
                        class="social-block__link"
                        aria-label="odnoklassniki">
                        <svg-icon name="icon-social-ok-dark" class="social-block__icon" />
                    </a>

                </div>

                <div class="footer__bottom">
                    <!-- eslint-disable-next-line -->
                    <p v-html="$t('copyright')"></p>
                    <p>
                        <!-- eslint-disable-next-line -->
                        <span v-html="$t('rights')"></span>
                        <span itemprop="copyrightYear">{{ new Date().getFullYear() }}</span>
                    </p>
                </div>
            </div>

        </footer>

        <div class="amp-layout-go-to-main">
            <a :href="canonicalUrl" class="amp-layout-button">Перейти в полную версию</a>
        </div>

        <button
            id="scrollToTopButton"
            class="button-up"
            on="tap:top.scrollTo(duration=200)">
            <svg-icon :name="'arrow-up'" />
        </button>

        <amp-animation id="showAnim" layout="nodisplay">
            <script type="application/json">
                {
                "duration": "200ms",
                "fill": "both",
                "iterations": "1",
                "direction": "alternate",
                "animations": [
                {
                "selector": "#scrollToTopButton",
                "keyframes": [
                { "opacity": "1", "visibility": "visible" }
                ]
                }
                ]
                }
            </script>
        </amp-animation>

        <amp-animation id="hideAnim" layout="nodisplay">
            <script type="application/json">
                {
                "duration": "300ms",
                "fill": "both",
                "iterations": "1",
                "direction": "alternate",
                "animations": [
                {
                "selector": "#scrollToTopButton",
                "keyframes": [
                { "opacity": "0", "visibility": "hidden" }
                ]
                }
                ]
                }
            </script>
        </amp-animation>

        <amp-analytics type="metrika"> 
            <script type="application/json"> 
                { 
                "vars": {
                "counterId": "13089175"
                },
                "triggers": {
                "notBounce": {
                "on": "timer",
                "timerSpec": {
                "immediate": false,
                "interval": 15,
                "maxTimerLength": 16
                },
                "request": "notBounce"
                }
                }
                }
            </script>
        </amp-analytics>

        <amp-analytics type="googleanalytics">
            <script type="application/json">
                {
                "vars": {
                "account": "UA-26774708-1"
                },
                "triggers": {
                "trackPageview": {
                "on": "visible",
                "request": "pageview"
                }
                }
                }
            </script>
        </amp-analytics>
    </div>
</template>

<script>
import get from 'lodash/get'
import pick from 'lodash/pick'
import includes from 'lodash/includes'

import { mapState, mapGetters } from 'vuex'

export default {
    async fetch(){
        await this.$api.get('statistics', {
            progress: false
        }).then(response => {
            this.counters = get(response, 'data.catalog', {})
        })

        if(this.$auth.loggedIn)
            await this.$api.get('/users/accounts/broadcasts', {
                progress: false
            }).then(results => {
                this.unreadNotifications = get(results, 'data.notifications.unread.total', 0)
            })
    },
    data(){
        return{
            user: this.$auth.user,
            unreadNotifications: 0,
            counters: {},
            totalPerfumes: 0,
            navs: {
                encyclopedia: {
                    opened: false,
                    sort: [
                        'perfumes',
                        'producers',
                        'brands',
                        'glossary',
                        'noses',
                        'shops',
                        'notes',
                        'sets',
                        'segments',
                        'perfumes_by_year',
                        'families',
                        'brands_by_country',
                        'concentrations',
                        'licensees',
                    ]
                },
                journal: {
                    opened: false,
                    sort: [
                        'feed',
                        'news',
                        'library',
                        'video'
                    ],
                },
                pages: {
                    opened: false,
                    sort: [
                        'about',
                        'community',
                        'help',
                        'cooperation',
                        'contacts',
                    ],
                },
            }
        }
    },
    computed: {
        ...mapGetters(['getSocialLinkUrl', 'getNewSections']),
        ...mapState(['nav']),
        canonicalUrl(){
            return this.$route.fullPath.replace('/amp/', '/')
        },
        placeholder() {
            const totalPerfumes = get(this.counters, 'perfumes.total', 0)
            if (totalPerfumes > 0){
                return this.$t('placeholder', {
                    total: `${this.$options.filters.numberDeclension(totalPerfumes, this.$t('declensions.perfumes_search_field'))}`
                }) + '...'
            }

            return null
        }
    },
    methods: {
        items(type, sort, max = null, min = null){
            const items = this.nav[type] || {}

            if(sort)
                return pick(items, sort)

            if(max){
                return Object.keys(items).slice(0, max).reduce((result, key) => {
                    result[key] = items[key]
                    return result
                }, {})
            }

            if(min){
                const arr = Object.keys(items)
                return arr.slice(min, arr.length).reduce((result, key) => {
                    result[key] = items[key]
                    return result
                }, {})
            }

            return items
        },
        getTranslation(key){
            const navKey = this.isFooter ? 'nav.footer.' : 'nav.'
            return this.$t(navKey + key)
        },
        getCountersDeclension(number) {
            return this.$options.filters.numberFormat(number);
        },
        isNew(item){
            return includes(this.getNewSections, get(item, 'url', null))
        },
        isCurrent(url){
            return includes(this.$route.path, url)
        }
    }
}
</script>